
import i18n from 'i18next';
import { PostCategoryResponsibles } from "./ApiCalls/categoryResponsibles/postCategoryResponsibles";
import { PatchCategoryResponsibles } from './ApiCalls/categoryResponsibles/patchCategoryResponsibles';
import { GetCategoryResponsiblesFromCompany } from './ApiCalls/categoryResponsibles/getCategoryResponsiblesFromCompany';
import { DeleteCategoryResponsibles } from './ApiCalls/categoryResponsibles/deleteCategoryResponsibles';

const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const modifiedBy = authInfo.idUser;

export async function PostCategoryResponsiblesService(categoryResponsibles) {
    try {
        const categoryResponsiblesData = await PostCategoryResponsibles(categoryResponsibles, modifiedBy);

        return true
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error

        return error;
    }
}

export async function PatchCategoryResponsiblesService(categoryResponsibles, idCategoryResponsible) {
    try {
        const categoryResponsiblesData = await PatchCategoryResponsibles(categoryResponsibles, modifiedBy, idCategoryResponsible);

        return true
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        return error;
    }
}


export async function GetCategoryResponsiblesFromCompanyService(company) {
    const response = await GetCategoryResponsiblesFromCompany(company);

    if (response.length > 0) {
        let categoryResponsibles = response
            .map((categoryResponsibleRes) => {
                return {
                    categoryResponsibleId: categoryResponsibleRes.categoryResponsible.categoryResponsible1,
                    incidentCategoryId: categoryResponsibleRes.categoryResponsible.incidentCategory,
                    categoryGroupId: categoryResponsibleRes.categoryResponsible.categoryGroup,
                    workplace: categoryResponsibleRes.categoryResponsible.workPlace,
                    companyId: categoryResponsibleRes.categoryResponsible.company,
                    responsibleId: categoryResponsibleRes.categoryResponsible.responsible ? categoryResponsibleRes.categoryResponsible.responsible : null,
                    companyName: categoryResponsibleRes.companyName,
                    workplaceName: categoryResponsibleRes.workPlaceName,
                    categoryName: categoryResponsibleRes.categoryName,
                    responsibleFullName: categoryResponsibleRes.responsibleName ? `${categoryResponsibleRes.responsibleName} ${categoryResponsibleRes.responsibleSurname}` : `${i18n.t("services:services.notAssigned")}`,
                    responsibleFullNameNIF: categoryResponsibleRes.responsibleName ? `${categoryResponsibleRes.responsibleName} ${categoryResponsibleRes.responsibleSurname} (${categoryResponsibleRes.responsibleNif || ""})` : `${i18n.t("services:services.notAssigned")}`,


                }
            })

        return categoryResponsibles;
    } else {
        return []
    }
}

export async function DeleteCategoryResponsiblesService(categoryResponsible) {

    const response = await DeleteCategoryResponsibles(categoryResponsible);

    return response;
}